import { createAction } from 'redux-actions';

export const ENVIROMENT_SET = 'ENVIRONMENT_SET';

export const setEnvironment = createAction(ENVIROMENT_SET);
